export const MOBILE_WIDTH = 768;

export const ROUTES = {
  nextLaunch: {
    path: '/',
    label: 'NEXT LAUNCH',
  },
  latestLaunch: {
    path: '/latest',
    label: 'LATEST LAUNCH',
  },
  statistics: {
    path: '/stats',
    label: 'STATISTICS',
  },
};
